// ----------------------------------------------------------------------
// <copyright file="Izenda.TitleModel.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

!(function() {
  var m = require('mobx');
  var UIConstants = require('logic/data/Izenda.UIConstants');

  const { isNil, clone } = require('lodash/fp');

  /**
   * Title model contain a title input which have text and font settings
   * @constructor
   */
  function TitleModel(data) {
    var props = {
      text: '',
      settings: {
        fontFamily: '',
        fontSize: UIConstants.defaultFontSize,
        fontBold: true,
        fontItalic: false,
        fontUnderline: false,
        fontColor: '',
        fontHighlightColor: '',
        alignment: ''
      }
    };

    m.extendObservable(this, props);

    data && this.populateData(data);
  }

  TitleModel.prototype.populateData = function(data) {
    if (isNil(data)) {
      return;
    }
    m.transaction(
      function() {
        this.updateText(data.text);
        this.updateSettings(clone(m.toJS(data.settings)));
      }.bind(this)
    );
  };

  /**
   * Update Text
   * @param {string} text
   */
  TitleModel.prototype.updateText = function(text) {
    this.text = text;
  };

  /**
   * Update setting
   * @param {object} settings
   */
  TitleModel.prototype.updateSettings = function(settings) {
    this.settings = settings;
  };

  module.exports = TitleModel;
})();



// WEBPACK FOOTER //
// ./ui/logic/models/Dashboard/Izenda.TitleModel.js